module.exports = __webpack_public_path__ + "img/wifi.f0648c4d.svg";